"use strict";

var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/string/#/contains/shim.js
// module id = 619
// module chunks = 22